import { render } from "./ProItem.vue?vue&type=template&id=94633dec"
import script from "./ProItem.vue?vue&type=script&lang=js"
export * from "./ProItem.vue?vue&type=script&lang=js"

import "./ProItem.vue?vue&type=style&index=0&id=94633dec&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__